const internalSiteExpanded = (state = [], action) => {
    switch(action.type) {
        case 'internalSiteExpanded':
            return action.payload;
        default:
            return state;
    }
}

export default internalSiteExpanded;